var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelEmailVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.95 86.0417L57.5 65.4917L78.05 86.0417L86.0416 78.05L65.4916 57.5L86.0416 36.95L78.05 28.9583L57.5 49.5083L36.95 28.9583L28.9583 36.95L49.5083 57.5L28.9583 78.05L36.95 86.0417ZM57.5 114.583C49.6034 114.583 42.1826 113.085 35.2375 110.088C28.2923 107.091 22.251 103.024 17.1135 97.8865C11.976 92.749 7.90881 86.7076 4.91194 79.7625C1.91506 72.8174 0.416626 65.3965 0.416626 57.5C0.416626 49.6035 1.91506 42.1826 4.91194 35.2375C7.90881 28.2924 11.976 22.251 17.1135 17.1135C22.251 11.976 28.2923 7.90885 35.2375 4.91198C42.1826 1.9151 49.6034 0.416664 57.5 0.416664C65.3965 0.416664 72.8173 1.9151 79.7625 4.91198C86.7076 7.90885 92.7489 11.976 97.8864 17.1135C103.024 22.251 107.091 28.2924 110.088 35.2375C113.085 42.1826 114.583 49.6035 114.583 57.5C114.583 65.3965 113.085 72.8174 110.088 79.7625C107.091 86.7076 103.024 92.749 97.8864 97.8865C92.7489 103.024 86.7076 107.091 79.7625 110.088C72.8173 113.085 65.3965 114.583 57.5 114.583Z",
    fill: "#F21D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelEmailVerify);
export default __webpack_public_path__ + "static/media/cancel_email_verify.2e338af4ad7f37b99753cfd8dc04e7d1.svg";
export { ForwardRef as ReactComponent };